<template>
  <div class="register pb-4 register__bg">
    <!-- <b-col class="col-12 align-content-center py-2 py-md-3 py-xl-4">
      <div class="mx-auto col-10 col-md-4 col-xl-3 py-2">
        <b-img
          :src="require(`@/assets/${$root.scope}/logo_area_pubblica.png`)"
          fluid-grow
          alt="logo app"
          style="max-height: 30vh"
        ></b-img>
      </div>
    </b-col> -->
    <div class="d-flex justify-content-between align-items-center px-5 py-5">
      <b-button class="fw-bold mb-0 register_back_btn" @click="goBack">
        {{ $t("indietro") }}
      </b-button>

      <b-img
        :src="require(`@/assets/${$root.scope}/logo_area_pubblica_reg.png`)"
        alt="Logo App"
        style="max-width: 130px"
        class="mb-0"
      />
    </div>

    <h2 class="mt-md-3 mb-2 register_title">{{ $t("registrazione") }}</h2>
    <p class="text-white" v-if="$root.scope === 'concura'">
      {{ $t("registrati_descrizione") }}
    </p>
    <p
      class="text-right text-secondary text-center"
      v-if="$root.scope === 'concura'"
    >
      <span @click="callSupport" class="pointer text-secondary">
        <b-iconstack :font-scale="2.5" class="point">
          <b-icon stacked icon="circle-fill" variant="primary"></b-icon>
          <b-icon
            stacked
            icon="telephone-fill"
            variant="secondary"
            scale="0.6"
          ></b-icon>
        </b-iconstack>
        <span
          id="login-phone-number"
          class="ml-3 text-white fw-bolder"
          style="font-size: 135%; vertical-align: text-bottom"
        >
          800.770.272
        </span>
      </span>
    </p>

    <div
      v-if="tab_index > 0"
      class="stepper d-flex justify-content-start align-items-start mb-4 col-lg-10 col-sm-10 mx-auto pl-0"
    >
      <div
        v-for="(step, index) in 5"
        :key="index"
        class="stepper-item text-center"
      >
        <div
          class="step-label"
          :class="{
            'active-text': tab_index === index + 1,
            'invisible-text': tab_index !== index + 1
          }"
        >
          Step {{ index + 1 }}
        </div>
        <div
          class="step-line"
          :class="{
            completed: tab_index > index + 1,
            active: tab_index === index + 1
          }"
        ></div>
      </div>
    </div>

    <div class="mt-md-4">
      <b-tabs no-key-nav v-model="tab_index" nav-class="d-none" class="w-100">
        <b-tab
          title-link-class="border-0 tab__no__hover"
          active-tab-class="border-0 tab__no__hover"
          title-item-class="border-0 tab__no__hover"
        >
          <b-card
            no-body
            class="col-lg-10 col-sm-12 mx-auto border-0 p-md-2 p-lg-4 bg-transparent"
          >
            <b-row class="px-md-4 pt-2">
              <b-col
                cols="8"
                class="my-2 mx-auto d-flex justify-content-center"
              >
                <div class="w-100 text-center" @click="selectUserType(0)">
                  <b-button block class="mb-1 w-100 register_btn">
                    {{ $t("sono_cittadino") }}
                  </b-button>
                </div>
              </b-col>
              <b-col
                cols="8"
                class="my-2 mx-auto d-flex justify-content-center"
              >
                <div class="w-100 text-center" @click="selectUserType(1)">
                  <b-button block class="mb-1 w-100 register_btn">
                    {{ $t("sono_operatore") }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <br />
            <p>
              <span class="text-dark">
                <a
                  target="_blank"
                  class="text-underlined register_title point"
                  :href="
                    form.type == 1
                      ? privacyPolicyLinks.operatore
                      : privacyPolicyLinks.paziente
                  "
                >
                  <u>{{ $t("consulta_informativa_privacy") }}</u>
                </a>
              </span>
            </p>
          </b-card>
        </b-tab>
        <b-tab
          title-link-class="bg-white border-0 tab__no__hover"
          active-tab-class="bg-white border-0 tab__no__hover"
          title-item-class="bg-white border-0 tab__no__hover"
          class="px-2"
        >
          <b-card
            no-body
            class="col-lg-10 col-sm-10 mx-auto border-0 pt-3 px-md-2 p-lg-4 bg-white"
          >
            <b-form @submit.prevent="onFirstStepSubmit">
              <div v-if="form.type === 1" class="text-left fs-6 mx-auto col-12">
                <b-col>
                  <label for="codice_azienda">Codice azienda</label>
                  <b-icon
                    class="ml-2"
                    icon="question-circle"
                    variant="secondary"
                    id="company-code-explain"
                  ></b-icon>
                </b-col>
                <b-tooltip
                  :placement="$root.isMobile ? 'bottom' : 'rightbottom'"
                  target="company-code-explain"
                  :triggers="$root.isMobile ? 'click' : 'hover'"
                >
                  Il codice azienda si trova nella sezione impostazioni
                  dell'operatore amministratore di struttura
                </b-tooltip>
              </div>
              <b-col>
                <b-form-group
                  v-if="form.type === 1"
                  class="text-left text-secondary mb-3 mx-auto col-12"
                  description="Inserisci il codice di 10 cifre fornito dalla tua azienda."
                >
                  <b-form-input
                    v-model="form.company_code"
                    minlength="10"
                    placeholder="Codice azienda"
                    class="my-3"
                    name="codice_azienda"
                    :state="form.company_code == null ? null : canSubmit"
                    required
                    v-on:input="checkCode"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <template v-if="form.type === 0">
                <b-col class="col-12 d-flex flex-wrap pb-2 pt-2">
                  <b-form-group
                    :label="$t('sono_cittadino_residente')"
                    label-for="gender"
                    class="text-left text-secondary col-12 col-sm-6"
                  >
                    <b-form-radio-group
                      v-model="anagrafica.estero"
                      name="estero"
                      class="d-flex pt-0 pb-2"
                      @change="resetEsteroFields"
                    >
                      <b-form-radio :value="false" class="mr-3"
                        >Si</b-form-radio
                      >
                      <b-form-radio :value="true">No</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
              </template>
              <div class="col-12 d-flex flex-wrap">
                <b-col class="col-12 col-sm-6 d-flex flex-wrap">
                  <b-form-group
                    :label="$t('titolo')"
                    label-for="title"
                    class="text-left text-secondary col-12 col-sm-4 pr-sm-1 mx-auto px-0"
                    :class="$root.isMobile ? '' : 'col'"
                  >
                    <b-form-select
                      v-capitalize-first-select
                      class="mb-3 mt-2 custom-select text-capitalize"
                      name="title"
                      v-model="anagrafica.title"
                      :options="titleOptions"
                    >
                      <b-form-select-option :value="null" disabled>{{
                        $t("titolo")
                      }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group
                    label="Nome*"
                    label-for="name"
                    class="text-left text-secondary col-12 col-sm-8 pl-sm-1 mx-auto px-0"
                    :class="$root.isMobile ? '' : 'col'"
                  >
                    <b-form-input
                      v-capitalize-first
                      class="my-3 text-capitalize"
                      name="name"
                      type="text"
                      :placeholder="$t('nome')"
                      v-model="anagrafica.name"
                      required
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-form-group
                  label="Cognome*"
                  label-for="surname"
                  class="text-left text-secondary col-12 col-sm-6 mx-auto"
                  :class="$root.isMobile ? '' : 'col'"
                >
                  <b-form-input
                    v-capitalize-first
                    class="my-3 text-capitalize"
                    name="surname"
                    type="text"
                    :placeholder="$t('cognome')"
                    v-model="anagrafica.surname"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <template v-if="form.type === 0">
                <div class="col-12 d-flex flex-wrap">
                  <b-form-group
                    v-if="anagrafica.estero === false"
                    label="Codice fiscale*"
                    label-for="cf"
                    class="text-left text-secondary col-12 col-sm-6"
                  >
                    <b-form-input
                      class="my-3 text-uppercase"
                      name="cf"
                      type="text"
                      :placeholder="$t('codice_fiscale')"
                      maxlength="16"
                      minlength="16"
                      v-model="anagrafica.cf"
                      :state="anagrafica.cf == null ? null : validCf"
                      required
                    ></b-form-input>
                  </b-form-group>
                  <!-- <b-form-group label="Numero Tessera Sanitaria" label-for="ts_number"
                    class="text-left col-12 col-sm-6 mx-auto" :class="$root.isMobile ? '' : 'col'">
                    <b-form-input class="my-3" name="ts_number" type="text" placeholder="Numero tessera"
                      v-model="anagrafica.ts_number" maxlength="20" minlength="20"></b-form-input>
                  </b-form-group> -->

                  <b-form-group
                    :label="$t('data_di_nascita') + '*'"
                    label-for="birthday"
                    class="text-left text-secondary col-12 col-sm-6"
                  >
                    <b-form-input
                      class="my-3"
                      name="birthday"
                      type="date"
                      v-model="anagrafica.birthday"
                      :state="anagrafica.birthday && validAge === false ? false : null"
                      required
                    />
                    <b-form-invalid-feedback :state="anagrafica.birthday && validAge === false ? false : null">
                      L'età minima per la registrazione è 14 anni
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group
                    v-if="anagrafica.estero === true"
                    :label="$t('genere')"
                    label-for="gender"
                    class="text-left text-secondary col-12 col-sm-6"
                  >
                    <b-form-radio-group
                      v-model="anagrafica.gender"
                      name="gender-options"
                      class="d-flex pt-0 pb-2 pb-md-0 pt-sm-3"
                    >
                      <b-form-radio value="maschile" class="mr-3">{{
                        $t("uomo")
                      }}</b-form-radio>
                      <b-form-radio value="femminile">{{
                        $t("donna")
                      }}</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </div>

                <div class="col-12 d-flex flex-wrap">
                  <b-form-group
                    v-if="anagrafica.estero === false"
                    label="Genere"
                    label-for="gender"
                    class="text-left text-secondary col-12 col-sm-6"
                  >
                    <b-form-radio-group
                      v-model="anagrafica.gender"
                      name="gender-options"
                      class="d-flex pt-0 pb-2 pb-md-0 pt-sm-3"
                    >
                      <b-form-radio value="maschile" class="mr-3"
                        >uomo</b-form-radio
                      >
                      <b-form-radio value="femminile">donna</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>

                  <b-form-group
                    :label="$t('nazione_nascita') + '*'"
                    label-for="nazione_di_nascita"
                    class="text-left text-secondary col-12 col-sm-6"
                  >
                    <b-form-select
                      v-capitalize-first-select
                      class="my-3 text-capitalize"
                      name="nazione_nascita"
                      v-model="anagrafica.nazione_nascita"
                      required
                    >
                      <b-form-select-option :value="null" key="nocount">{{
                        $t("nazione_nascita")
                      }}</b-form-select-option>
                      <b-form-select-option value="italia" key="italia"
                        >italia</b-form-select-option
                      >
                      <b-form-select-option
                        v-for="(nazione, ind) in nazioni"
                        :value="nazione.nazione"
                        :key="ind + '_' + nazione.nazione"
                      >
                        {{ nazione.nazione }}
                      </b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </template>

              <div
                class="col-12 pb-2 d-flex flex-wrap justify-content-center justify-content-lg-end"
              >
                <b-button
                  type="submit"
                  variant="secondary text-white col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 my-2"
                  :disabled="!enableFirstBtn"
                >
                  <strong>{{ $t("avanti") }} </strong>
                  <b-icon icon="arrow-right"></b-icon>
                </b-button>
              </div>
            </b-form>
          </b-card>
        </b-tab>

        <b-tab
          title-link-class="bg-white border-0 tab__no__hover"
          active-tab-class="bg-white border-0 tab__no__hover"
          title-item-class="bg-white border-0 tab__no__hover"
          class="px-2"
        >
          <b-card
            no-body
            class="col-lg-10 col-sm-10 mx-auto border-0 pt-3 px-md-2 p-lg-4 bg-white"
          >
            <b-form @submit.prevent="tab_index++">
              <div class="col-12 d-flex flex-wrap">
                <b-form-group
                  v-if="anagrafica.estero === false"
                  label="Regione di residenza*"
                  label-for="regione"
                  class="text-left text-secondary col-12 col-sm-6"
                >
                  <b-form-select
                    v-capitalize-first-select
                    class="my-3 text-capitalize"
                    name="regione"
                    v-model="selected.regione"
                    @change="getProvince(selected)"
                    required
                  >
                    <b-form-select-option :value="null" key="noreg">{{
                      $t("seleziona_regione")
                    }}</b-form-select-option>
                    <b-form-select-option
                      v-for="regione in regioni"
                      :value="regione"
                      :key="regione"
                      >{{ regione }}</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
                <b-form-group
                  v-if="anagrafica.estero === false"
                  label="Provincia di residenza*"
                  label-for="provincia"
                  class="text-left text-secondary col-12 col-sm-6 mx-auto"
                >
                  <b-form-select
                    v-capitalize-first-select
                    class="my-3 text-capitalize"
                    name="provincia"
                    v-model="selected.provincia"
                    @change="getComuni(selected)"
                    required
                  >
                    <b-form-select-option :value="null">{{
                      $t("seleziona_provincia")
                    }}</b-form-select-option>
                    <b-form-select-option
                      v-for="provincia in province"
                      :value="provincia"
                      :key="provincia"
                      >{{ provincia }}</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
                <b-form-group
                  v-else
                  label="Provincia di residenza*"
                  label-for="provincia"
                  class="text-left text-secondary col-12 col-sm-6 mx-auto"
                >
                  <b-form-input
                    v-capitalize-first
                    class="my-3"
                    name="provincia"
                    type="text"
                    required
                    :placeholder="$t('provincia')"
                    v-model="anagrafica.provincia"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  v-if="anagrafica.estero === false"
                  label="Comune di residenza*"
                  label-for="comune"
                  class="text-left text-secondary col-12 col-sm-6 mx-auto"
                >
                  <b-form-select
                    v-capitalize-first-select
                    class="my-3 text-capitalize"
                    name="comune"
                    v-model="selected.comune"
                    :key="
                      comuni && comuni.length
                        ? comuni[0].comune + comuni.length
                        : null
                    "
                    required
                  >
                    <b-form-select-option
                      v-for="(com, ind) in comuni"
                      :key="ind + '_' + com.comune"
                      :value="com"
                      @change="setDomicilioData"
                      >{{ com.comune }}</b-form-select-option
                    >
                    <b-form-select-option :value="null">{{
                      $t("seleziona_comune")
                    }}</b-form-select-option>
                  </b-form-select>
                </b-form-group>
                <b-form-group
                  v-else
                  label="Comune di residenza*"
                  label-for="comune"
                  class="text-left text-secondary col-12 col-sm-6 mx-auto"
                >
                  <b-form-input
                    v-capitalize-first
                    class="my-3"
                    name="comune"
                    type="text"
                    required
                    :placeholder="$t('comune')"
                    v-model="anagrafica.comune"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="Indirizzo e numero civico*"
                  label-for="address"
                  class="text-left text-secondary col-12 col-sm-6 mx-auto"
                >
                  <b-form-input
                    v-capitalize-first
                    class="my-3"
                    name="address"
                    type="text"
                    required
                    :placeholder="$t('placeholder_indirizzo')"
                    v-model="anagrafica.address"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  v-if="anagrafica.estero === false"
                  label="CAP*"
                  label-for="cap"
                  class="text-left text-secondary col-12 col-sm-6 mr-auto"
                >
                  <b-form-input
                    class="my-3"
                    name="cap"
                    type="text"
                    required
                    :placeholder="$t('placeholder_cap')"
                    v-model="anagrafica.cap"
                    minlength="5"
                    maxlength="5"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  v-else
                  label="Zip Code*"
                  label-for="cap"
                  class="text-left text-secondary col-12 col-sm-6 mr-auto"
                >
                  <b-form-input
                    class="my-3"
                    name="cap"
                    type="text"
                    required
                    :placeholder="$t('placeholder_cap')"
                    v-model="anagrafica.cap"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div
                class="col-12 pb-2 d-flex flex-wrap justify-content-center justify-content-lg-end"
              >
                <b-button
                  type="submit"
                  variant="secondary text-white col-12 col-sm-4 col-md-3 my-2 my-sm-0  col-xl-2 mx-2"
                  :disabled="!enableSecondBtn"
                  >Avanti
                  <b-icon icon="arrow-right"></b-icon>
                </b-button>
              </div>
            </b-form>
          </b-card>
        </b-tab>

        <b-tab
          title-link-class="bg-white border-0 tab__no__hover"
          active-tab-class="bg-white border-0 tab__no__hover"
          title-item-class="bg-white border-0 tab__no__hover"
          class="px-2"
        >
          <b-card
            no-body
            class="col-lg-10 col-sm-10 mx-auto border-0 pt-3 px-md-2 p-lg-4 bg-white"
          >
            <b-form @submit.prevent="onRegister">
              <div class="col-12 d-flex flex-wrap">
                <b-form-group
                  label="Email*"
                  label-for="email"
                  class="text-left text-secondary pt-2 col-12 col-sm-6"
                >
                  <b-form-input
                    v-model="form.email"
                    :placeholder="$t('email')"
                    class="my-3"
                    name="email"
                    autocomplete="username"
                    :state="form.email == null ? null : validEmail"
                    :disabled="!anagrafica.name || !anagrafica.surname"
                    required
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  :label="$t('numero_telefono') + '*'"
                  label-for="tel_number"
                  class="text-left text-secondary col-12 pt-2 pt-sm-0 col-sm-6 d-flex flex-column"
                >
                  <b-input-group class="">
                    <b-input-group-prepend>
                      <b-form-select
                        class="my-3 text-capitalize prefix-select"
                        name="prefix"
                        v-model="anagrafica.prefix"
                        required
                      >
                        <b-form-select-option
                          v-for="(prefisso, index) in prefissi"
                          :value="prefisso.prefisso"
                          :key="`${prefisso.prefisso}-${index}`"
                          >{{ prefisso.flag }}
                          {{ prefisso.prefisso }}</b-form-select-option
                        >
                      </b-form-select>
                    </b-input-group-prepend>
                    <b-form-input
                      class="my-3"
                      name="tel_number"
                      type="text"
                      :placeholder="$t('telefono')"
                      v-model="anagrafica.tel_number"
                      minlength="9"
                      maxlength="15"
                      required
                      :state="
                        anagrafica.tel_number !== null ? validNumber : null
                      "
                      @input="onPhoneInput"
                    ></b-form-input>
                  </b-input-group>
                  <b-form-invalid-feedback
                    v-if="anagrafica.tel_number && !validNumber"
                  >
                    <span
                      v-if="
                        anagrafica.tel_number &&
                        anagrafica.tel_number.length > 15
                      "
                    >
                      Il numero di telefono non può superare 15 cifre.
                    </span>
                    <span
                      v-else-if="
                        anagrafica.tel_number &&
                        !/^\d+$/.test(anagrafica.tel_number)
                      "
                    >
                      Il numero di telefono deve contenere solo cifre.
                    </span>
                    <span
                      v-else-if="
                        anagrafica.tel_number &&
                        anagrafica.tel_number.length < 9
                      "
                    >
                      Il numero di telefono deve contenere almeno 9 cifre.
                    </span>
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  :label="$t('telefono_fisso')"
                  label-for="home_number"
                  class="text-left text-secondary col-12 col-sm-6 mr-auto"
                >
                  <b-form-input
                    class="my-3"
                    name="home_number"
                    type="text"
                    :placeholder="$t('telefono_fisso')"
                    v-model="anagrafica.home_number"
                    minlength="9"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  v-if="projects && form.type === 0"
                  :label="$t('aderisco_progetto') + '*'"
                  label-for="project"
                  class="text-left text-secondary col-12 col-sm-6"
                >
                  <b-form-select
                    class="mb-3 mt-2 text-capitalize"
                    name="project"
                    v-model="form.project"
                    required
                  >
                    <b-form-select-option :value="null" disabled>
                      --
                    </b-form-select-option>
                    <b-form-select-option
                      v-for="project in projects"
                      :value="project.hashid"
                      :key="project.hashid"
                      >{{ project.name }}</b-form-select-option
                    >
                    <b-form-select-option value="nessuno">{{
                      $t("nessun_progetto")
                    }}</b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </div>
              <div class="col-12 d-flex flex-wrap">
                <template v-if="form.type === 1">
                  <b-form-group
                    label="Ordine"
                    label-for="tipo_albo"
                    class="text-left text-secondary col-12 col-sm-6"
                  >
                    <b-form-select
                      v-capitalize-first-select
                      class="mb-3 mt-2 custom-select text-capitalize"
                      name="tipo_albo"
                      v-model="anagrafica.tipo_albo"
                      :options="tipoAlboOptions"
                    >
                    </b-form-select>
                  </b-form-group>
                  <b-form-group
                    label="
                      ID Iscrizione Albo**
                    "
                    label-for="id_albo"
                    class="text-left text-secondary col-12 col-sm-6"
                    :description="'**Includere la sigla provincia'"
                  >
                    <b-form-input
                      class="my-3 text-capitalize"
                      name="id_albo"
                      type="text"
                      placeholder="ID ordine"
                      v-model="anagrafica.id_albo"
                      :state="validIdOrdine"
                      @input="
                        (val) =>
                          (anagrafica.id_albo =
                            anagrafica.id_albo.toUpperCase())
                      "
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    label="Specializzazione"
                    label-for="specializzazione"
                    class="text-left text-secondary col-12 col-sm-6"
                  >
                    <b-form-input
                      class="my-3"
                      name="specializzazione"
                      type="text"
                      placeholder="Specializzazione medica..."
                      v-model="anagrafica.specializzazione"
                    ></b-form-input>
                  </b-form-group>
                </template>
              </div>
              <div
                class="col-12 pb-2 d-flex flex-wrap justify-content-center justify-content-lg-end"
              >
                <b-button
                  type="submit"
                  variant="secondary text-white col-12 col-sm-4 col-md-3 my-2 my-sm-0  col-xl-2 mx-2"
                  :disabled="!enableThirdBtn"
                  >Avanti
                  <b-icon icon="arrow-right"></b-icon>
                </b-button>
              </div>
            </b-form>
          </b-card>
        </b-tab>

        <b-tab
          title-link-class="bg-white border-0 tab__no__hover"
          active-tab-class="bg-white border-0 tab__no__hover"
          title-item-class="bg-white border-0 tab__no__hover"
          class="px-2"
        >
          <b-card
            no-body
            class="col-lg-10 col-sm-10 mx-auto border-0 pt-3 px-md-2 p-lg-4 bg-white"
          >
            <b-form @submit.prevent="tab_index++">
              <div class="col-12 d-flex flex-wrap">
                <b-form-group
                  label="Password*"
                  label-for="password"
                  class="text-left text-secondary col-12 col-sm-6 mx-auto"
                >
                  <b-form-input
                    class="my-3"
                    name="password"
                    :type="passwordClear ? 'text' : 'password'"
                    v-model="form.password"
                    :placeholder="$t('password')"
                    autocomplete="new-password"
                    :state="form.password == null ? null : validatePassword"
                    required
                  >
                  </b-form-input>
                  <b-icon
                    :icon="passwordClear ? 'eye' : 'eye-slash'"
                    font-scale="1.3"
                    class="eye_icon point"
                    @click="passwordClear = !passwordClear"
                  ></b-icon>
                </b-form-group>
                <b-form-group
                  :label="$t('conferma_password') + '*'"
                  label-for="password"
                  class="text-left text-secondary col-12 col-sm-6 mx-auto"
                  :class="$root.isMobile ? '' : 'col'"
                >
                  <b-form-input
                    class="my-3"
                    name="password_confirmation"
                    :type="passwordConfirmClear ? 'text' : 'password'"
                    v-model="form.password_confirmation"
                    :placeholder="$t('conferma_password')"
                    :state="form.password == null ? null : validateConfirm"
                    required
                  ></b-form-input>

                  <b-icon
                    :icon="passwordConfirmClear ? 'eye' : 'eye-slash'"
                    font-scale="1.3"
                    class="eye_icon point"
                    @click="passwordConfirmClear = !passwordConfirmClear"
                  ></b-icon>
                </b-form-group>
                <p class="text-left text-medium-grey col fs-6">
                  {{ $t("password_requisiti") }}
                  <span v-b-tooltip :title="$t('tooltip_carattere_speciale')">{{
                    $t("carattere_speciale")
                  }}</span
                  >.
                </p>
              </div>
              <p
                v-if="form.project && form.project !== 'nessuno'"
                class="text-left text-medium-grey col-12 pl-4 ml-1"
              >
                {{
                  $t("progetto_selezionato_testo", {
                    projectName: findProjectName(form.project).name
                  })
                }}
              </p>
              <br />
              <div
                class="col-12 pb-2 d-flex flex-wrap justify-content-center justify-content-lg-end"
              >
                <b-button
                  type="submit"
                  variant="secondary text-white col-12 col-sm-4 col-md-3 my-2 my-sm-0  col-xl-2 mx-2"
                  :disabled="!enableFourthBtn"
                  >Avanti
                  <b-icon icon="arrow-right"></b-icon>
                </b-button>
              </div>

              <p>
                <span class="text-dark">
                  <a
                    target="_blank"
                    class="text-underlined point"
                    :href="
                      form.type == 1
                        ? privacyPolicyLinks.operatore
                        : privacyPolicyLinks.paziente
                    "
                  >
                    <u>{{ $t("consulta_informativa_privacy") }}</u></a
                  >
                </span>
              </p>
            </b-form>
          </b-card>
        </b-tab>

        <b-tab
          title-link-class="bg-white border-0 tab__no__hover"
          active-tab-class="bg-white border-0 tab__no__hover"
          title-item-class="bg-white border-0 tab__no__hover"
          class="px-2"
        >
          <b-card
            no-body
            class="col-lg-10 col-sm-10 mx-auto border-0 pt-3 px-md-2 p-lg-4 bg-white"
          >
            <div class="col-12">
              <h6 class="text-left pb-1">
                {{ $t("termini_condizioni_privacy") }}
              </h6>
              <p class="text-justify informativa__p">
                {{ $t("concludi_registrazione_testo") }}
                <a
                  target="_blank"
                  class="text-underlined point"
                  :href="infoLinks.paziente"
                >
                  <u>{{ $t("termini_condizioni_link") }}</u></a
                >
                e
                <a
                  target="_blank"
                  class="text-underlined point"
                  :href="
                    form.type == 1
                      ? privacyPolicyLinks.operatore
                      : privacyPolicyLinks.paziente
                  "
                >
                  <u>{{ $t("informativa_privacy_link") }}</u></a
                >
              </p>
              <b-row cols="1" class="text-left">
                <b-form-checkbox
                  class="text-font-light-grey"
                  name="charge_consense"
                  :value="true"
                  :unchecked-value="false"
                  v-model="form.charge_consense"
                  :state="form.charge_consense == true"
                >
                  <span class="text-dark"
                    >{{ $t("accetto_informativa_privacy") }}
                    <a
                      target="_blank"
                      class="text-underlined point"
                      :href="
                        form.type == 1
                          ? privacyPolicyLinks.operatore
                          : privacyPolicyLinks.paziente
                      "
                    >
                      <u>{{ $t("informativa_privacy_link") }}</u></a
                    >
                  </span>
                </b-form-checkbox>
                <b-form-checkbox
                  class="text-font-light-grey"
                  name="charge_consense"
                  :value="false"
                  :unchecked-value="false"
                  v-model="form.charge_consense"
                  :state="false"
                >
                  {{ $t("non_accetto") }}
                </b-form-checkbox>
              </b-row>
              <p class="text-justify informativa__p my-4"></p>
              <b-row cols="1" class="text-left">
                <b-form-checkbox
                  class="text-font-light-grey"
                  name="data_consense"
                  :value="true"
                  :unchecked-value="false"
                  v-model="form.data_consense"
                  :state="form.data_consense == true"
                >
                  <span class="text-dark"
                    >{{ $t("accetto_termini_condizioni") }}
                    <a
                      target="_blank"
                      class="text-underlined point"
                      :href="infoLinks.paziente"
                    >
                      <u>{{ $t("termini_condizioni_uso") }}</u></a
                    >
                  </span>
                </b-form-checkbox>
                <b-form-checkbox
                  class="text-font-light-grey"
                  name="data_consense"
                  :value="false"
                  :unchecked-value="false"
                  v-model="form.data_consense"
                  :state="false"
                >
                  {{ $t("non_accetto") }}
                </b-form-checkbox>
              </b-row>
              <p class="text-justify informativa__p my-4">e</p>
              <b-row cols="1" class="text-left">
                <b-form-checkbox
                  class="text-font-light-grey"
                  name="share_consense"
                  :value="true"
                  :unchecked-value="false"
                  v-model="form.share_consense"
                  :state="form.share_consense == true"
                >
                  <span class="text-dark"
                    >Ai sensi dell'articolo 1341 e ss c.c. accetto espressamente
                    le previsioni di cui agli articoli 2, 7, 8, 10, 12 dei
                    presenti
                    <a
                      target="_blank"
                      class="text-underlined point"
                      :href="infoLinks.paziente"
                    >
                      <u>{{ $t("termini_condizioni_uso") }}</u></a
                    >
                  </span>
                </b-form-checkbox>
                <b-form-checkbox
                  class="text-font-light-grey"
                  name="share_consense"
                  :value="false"
                  :unchecked-value="false"
                  v-model="form.share_consense"
                  :state="false"
                >
                  {{ $t("non_accetto") }}
                </b-form-checkbox>
              </b-row>
              <h6 class="text-left pt-4 pb-1">
                {{ $t("autorizzazione_marketing") }}
              </h6>
              <b-row cols="1" class="text-left">
                <b-form-checkbox
                  class="text-font-light-grey"
                  name="marketing_consense"
                  :value="true"
                  :unchecked-value="false"
                  v-model="form.marketing_consense"
                  :state="form.marketing_consense == true"
                >
                  <span class="text-dark"
                    >{{ $t("accetto_marketing") }}
                    <a
                      target="_blank"
                      class="text-underlined point"
                      :href="
                        form.type == 1
                          ? privacyPolicyLinks.operatore
                          : privacyPolicyLinks.paziente
                      "
                    >
                      <u>{{ $t("informativa_privacy_link") }}</u></a
                    >
                  </span>
                </b-form-checkbox>
                <b-form-checkbox
                  class="text-font-light-grey"
                  name="marketing_consense"
                  :value="false"
                  :unchecked-value="false"
                  v-model="form.marketing_consense"
                  :state="false"
                >
                  {{ $t("non_accetto") }}
                </b-form-checkbox>
              </b-row>
            </div>
            <br />
            <div
              class="col-12 pb-2 d-flex flex-wrap justify-content-center justify-content-lg-end"
            >
              <b-button
                type="button"
                variant="secondary text-white mx-2"
                :disabled="!enableCompleteBtn"
                @click.prevent="OnSubmit"
              >
                {{ $t("completa") }}
              </b-button>
            </div>
          </b-card>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

import { mapState, mapActions } from "vuex"
import * as moment from "moment/moment"
import { utilityService } from "@/_services"
import { PREFIX_PAESI } from "@/_utils/constants.js"

export default {
  name: "RegisterPage",
  components: {
    // HelloWorld,
  },
  data() {
    return {
      form: {
        email: null,
        password: null,
        password_confirmation: null,
        data_consense: false,
        share_consense: false,
        notification_consense: true,
        charge_consense: false,
        marketing_consense: true,
        type: null,
        project: null,
        // company_code: null,
        anagrafica: null
      },
      anagrafica: {
        regione: null,
        provincia: null,
        comune: null,
        cap: null,
        address: null,
        name: null,
        surname: null,
        cf: null,
        gender: null,
        birthday: null,
        ts_number: null,
        prefix: "+39",
        tel_number: null,
        home_number: null,
        title: null,
        id_albo: null,
        tipo_albo: null,
        specializzazione: null,
        nazione_nascita: "italia",
        estero: false
      },
      titleOptions: ["Sig.", "Sig.ra", "Dott.", "Dott.ssa"],
      tipoAlboOptions: [
        { value: null, text: "Ordine" },
        "Medici", 
        "Dentisti", 
        "Farmacisti", 
        "Infermieri", 
        "Biologi"
      ],
      nazioni: [],
      has_minimum_lenth: true,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      has_special: false,
      has_name: false,
      has_surname: false,
      tab_index: 0,
      canSubmit: false,
      selected: {
        regione: null,
        provincia: null,
        comune: null
      },
      cfMonths: {
        A: "01",
        B: "02",
        C: "03",
        D: "04",
        E: "05",
        H: "06",
        L: "07",
        M: "08",
        P: "09",
        R: "10",
        S: "11",
        T: "12",
        a: "01",
        b: "02",
        c: "03",
        d: "04",
        e: "05",
        h: "06",
        l: "07",
        m: "08",
        p: "09",
        r: "10",
        s: "11",
        t: "12"
      },
      infoLinks: {
        paziente: process.env.VUE_APP_LINK_TC_PAZIENTE,
        operatore: process.env.VUE_APP_LINK_TC_OPERATORE
      },
      privacyPolicyLinks: {
        paziente: process.env.VUE_APP_LINK_INFORMATIVA_PAZIENTE,
        operatore: process.env.VUE_APP_LINK_INFORMATIVA_OPERATORE
      },
      // infoLinks: {
      //   // paziente: process.env.VUE_APP_LINK_INFO_REGISTRAZIONE_PAZIENTE,
      //   // operatore: process.env.VUE_APP_LINK_INFO_REGISTRAZIONE_OPERATORE,
      //   // paziente: "/assets/docs/TeC.pdf",
      //   // operatore: "/assets/docs/TeC.pdf",
      //   paziente: "https://concura.online/wp-content/uploads/2024/07/TC.pdf",
      //   operatore: "https://concura.online/wp-content/uploads/2024/07/TC.pdf",
      // },
      passwordClear: false,
      passwordConfirmClear: false,
      prefissi: PREFIX_PAESI
    }
  },
  watch: {
    selected: {
      handler(val) {
       if (val.comune !== null) {
         this.anagrafica.comune = this.selected.comune.comune
          this.anagrafica.provincia = this.selected.comune.provincia
          this.anagrafica.regione = this.selected.comune.regione
        }
      },
      deep: true
    },
    tab_index: function (val) {
      if (val == 2) {
        window.scrollTo(0, 0)
      }
    }
  },
  computed: {
    validatePassword() {
      if (!this.anagrafica.name || !this.anagrafica.surname) {
        return null
      }
      if (this.form.password) {
        this.has_minimum_lenth = this.form.password.length > 8
        this.has_number = /\d/.test(this.form.password)
        this.has_lowercase = /[a-z]/.test(this.form.password)
        this.has_uppercase = /[A-Z]/.test(this.form.password)
        this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(this.form.password)
        const regName = new RegExp(
          this.anagrafica.name.toLowerCase().replace(/\s+/g, "")
        )
        this.has_name = !regName.test(this.form.password.toLowerCase())
        const regSurname = new RegExp(
          this.anagrafica.surname.toLowerCase().replace(/\s+/g, "")
        )
        this.has_surname = !regSurname.test(this.form.password.toLowerCase())
        return (
          this.has_minimum_lenth &&
          this.has_number &&
          this.has_lowercase &&
          this.has_uppercase &&
          this.has_name &&
          this.has_surname &&
          this.has_special
        )
      }
      return false
    },
    validCf() {
      var validRegex =
        /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/
      if (this.anagrafica.estero) {
        return true
      }
      if (this.anagrafica.cf.length === 16) {
        return this.anagrafica.cf.match(validRegex) ? this.fillOthers() : false
      }
      return this.anagrafica.cf.match(validRegex) ? true : false
    },
    validNumber() {
      const v = this.anagrafica.tel_number || "";
      if (!v) return false;
      // Nuova regola: solo cifre e lunghezza tra 9 e 15
      const onlyDigitsLen = /^\d{9,15}$/.test(v);
      // Regole esistenti: non deve iniziare con 0/00 e non deve contenere '+'
      const prefix = v.slice(0, 2);
      const hasForbiddenPrefix = prefix === "00" || v.indexOf("+") >= 0 || v.indexOf("0") === 0;
      return onlyDigitsLen && !hasForbiddenPrefix;
    },
    validateConfirm() {
      if (this.form.password) {
        return this.form.password_confirmation === this.form.password
      }
      return false
    },
    validIdOrdine() {
      if (this.anagrafica.id_albo) {
        const regx = /^[A-Za-z]{2}/
        return this.anagrafica.id_albo.match(regx) ? true : false
      }
      return null
    },
    validEmail() {
      var validRegex =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      return this.form.email.match(validRegex) ? true : false
    },
    enableFirstBtn() {
      if (this.form.type === 0) {
        return (
          this.anagrafica.name &&
          this.anagrafica.surname &&
          (this.anagrafica.cf || this.anagrafica.estero) &&
          this.anagrafica.birthday &&
          this.anagrafica.nazione_nascita &&
          this.validCf &&
          this.validAge
        )
      } else if (this.form.type === 1) {
        return this.anagrafica.name && this.anagrafica.surname
      }
      return false // Nessun tipo selezionato
    },
    enableSecondBtn() {
      return (
        (this.selected.regione || this.anagrafica.estero) &&
        (this.selected.provincia || this.anagrafica.provincia) &&
        (this.selected.comune || this.anagrafica.comune) &&
        this.anagrafica.address &&
        this.anagrafica.cap
      )
    },
    enableThirdBtn() {
      if (this.form.type === 0) {
        return (
          this.form.email &&
          this.anagrafica.tel_number &&
          this.validNumber &&
          this.form.project &&
          this.validEmail
        )
      } else if (this.form.type === 1) {
        return (
          this.form.email &&
          this.anagrafica.tel_number &&
          this.validNumber &&
          this.validEmail &&
          this.anagrafica.id_albo
        )
      }
    },
    enableFourthBtn() {
      return this.validatePassword && this.validateConfirm
    },
    enableCompleteBtn() {
      if (
        this.form.data_consense &&
        this.form.share_consense &&
        this.form.charge_consense
      ) {
        // if (this.form.type == 0 && !this.form.charge_consense) {
        //   return false;
        // }
        return true
      }
      return false
    },
    validAge() {
      if (!this.anagrafica.birthday) {
        return null
      }
      const birthDate = moment(this.anagrafica.birthday)
      const today = moment()
      const age = today.diff(birthDate, "years")
      return age >= 14
    },
    ...mapState("utility", [
      "searching",
      "comuni",
      "province",
      "regioni",
      "projects"
    ])
  },
  methods: {
    ...mapActions("utente", ["register"]),
    ...mapActions("utility", [
      "getComuni",
      "getProvince",
      "getRegioni",
      "getProjects"
    ]),
    resetEsteroFields() {
      this.anagrafica.cf = null
      this.anagrafica.regione = null
      this.anagrafica.provincia = null
      this.anagrafica.comune = null
      this.anagrafica.cap = null
    },
    OnSubmit() {
      if (
        this.anagrafica.estero === false &&
        this.anagrafica.cf &&
        !this.validCf
      ) {
        this.errorAlert(
          "I termini e le condizioni e l'informativa sulla privacy devono essere accettati per proseguire"
        )
        return
      }
      // if (this.form.type === 1) {
      //   this.form.charge_consense = undefined
      // } else {
      //   // this.form.company_code = undefined;
      // }
      // console.log(this.form);
      if (this.form) {
        if (this.form.project && this.form.project === "nessuno") {
          this.form.project = null
        }
        // Per gli operatori, rimuoviamo il progetto dal form
        if (this.form.type === 1) {
          this.form.project = null
        }
        this.form.anagrafica = this.anagrafica
        this.register(this.form)
          .then((res) => {
            window.scrollTo(0, 0)
          })
          .catch((error) => {
            console.log("after login error", error)
          })
      }
      this.tab_index++
    },
    checkCode() {
      // console.log(this.form.company_code);
      // console.log(this.form.company_code.length);
      if (this.form.company_code !== null) {
        this.canSubmit = this.form.company_code.length >= 10
      }
    },
    setDomicilioData() {
      // console.log("on change", this.selected.comune);
      if (this.selected.comune) {
        this.anagrafica.comune = this.selected.comune.comune
        this.anagrafica.provincia = this.selected.comune.provincia
        this.anagrafica.regione = this.selected.comune.regione
      }
    },
    findComune(comune) {
      if (this.anagrafica.comune) {
        if (comune.comune === this.anagrafica.comune) {
          this.selected.comune = comune
          return true
        }
      }
      return false
    },
    fillOthers() {
      // console.log("fillOthers");
      try {
        var cf = this.anagrafica.cf
        let getYear = cf.substr(6, 2)
        let getMonth = this.cfMonths[cf.substr(8, 1)]
        let getDay = parseInt(cf.substr(9, 2))
        let day = getDay > 31 ? getDay - 40 : getDay
        this.anagrafica.gender = getDay > 31 ? "femminile" : "maschile"
        // console.log(parseInt(getYear));
        let currentYear = moment().year() - 2000
        let yearPrefix =
          parseInt(getYear) >= 0 && parseInt(getYear) <= currentYear
            ? "20"
            : "19"
        var stringBDate = yearPrefix + getYear + "/" + getMonth + "/" + day
        var isDateValid = moment(stringBDate).isValid()
        // console.log(isDateValid);
        this.anagrafica.birthday = moment(stringBDate).format("yyyy-MM-DD")
        //un codice fiscale è estero se z è il carattere in 12sima posizione
        if (cf.substr(11, 1) === "Z") {
          this.anagrafica.nazione_nascita = this.nazioni.find(
            (nazione) => nazione.codice === cf.substr(11, 4)
          )?.nazione
        } else {
          this.anagrafica.nazione_nascita = "italia"
          this.searchComuneViaCCatastale(cf.substr(11, 4))
        }

        return isDateValid
      } catch (err) {
        // console.log("fillOthers", err);
        return false
      }
    },
    searchComuneViaCCatastale(codice) {
      const self = this
      utilityService
        .searchComuneViaCodiceCatastale(codice)
        .then(function (res) {
          // console.log(res.data.data)
          if (res.data.data) {
            self.selected.regione = res.data.data.regione
            self.getProvince(res.data.data)
            self.selected.provincia = res.data.data.provincia
            self.getComuni(res.data.data)
            self.selected.comune = res.data.data
          }
        })
        .catch(function (err) {
          console.log(err)
        })
    },
    getNazioni() {
      var self = this
      utilityService
        .nazioni()
        .then((res) => {
          self.nazioni = res.data
          // console.log(res.data)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    findProjectName(hashid) {
      // Object.keys();this.project
      return this.projects.find((el) => el.hashid === hashid)
    },
    callSupport() {
      window.location.href = "tel:800770272"
    },
    selectUserType(type) {
      this.form.type = type
      this.tab_index = 1
      if (type === 1 && this.blockOperatore) {
        this.infoAlert("App non disponibile per utenze di tipo Operatore")
      }
    },
    goBack() {
      if (this.tab_index > 1) {
        this.tab_index--
      } else {
        this.$router.push("/login")
      }
    },
    onRegister() {
      if (this.anagrafica.birthday && this.validAge === false) {
        this.errorAlert("L'età minima per la registrazione è 14 anni")
        return
      }
      if (!this.validNumber) {
        this.errorAlert(
          "Il numero di telefono deve contenere solo cifre e non superare 15 caratteri"
        )
        return
      }
      this.tab_index++
    },
    onPhoneInput(e) {
      // Rimuove caratteri non numerici in tempo reale
      this.anagrafica.tel_number = (this.anagrafica.tel_number || "")
        .replace(/\D/g, "")
        .slice(0, 15)
    },
    onFirstStepSubmit() {
      if (this.anagrafica.birthday && this.validAge === false) {
        this.errorAlert("L'età minima per la registrazione è 14 anni")
        return
      }
      this.tab_index++
    }
  },
  created() {
    this.getRegioni()
    this.getNazioni()
    this.getProjects({ active: true, public: true })
    if (this.$route.query.type && this.$route.query.type === "cittadino") {
      this.form.type = 0
      this.tab_index++
    }
  }
}
</script>
<style lang="scss" scoped>
.registration-type-tile {
  padding: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 0.85rem;
}

.eye_icon {
  position: absolute;
  right: 53px;
  top: 3.4rem;
  color: #9c9c9c;
}

.prefix-select {
  min-width: 120px !important;
  max-width: 120px !important;
}

@media screen and (max-width: 767px) {
  .registration-type-tile {
    padding: 0.8rem;
    height: 75px;
  }
}

@media screen and (min-width: 768px) {
  .registration-type-tile {
    height: 100%;
  }
}
</style>
